import { Link, usePage } from '@inertiajs/react';
import { Heart, Search, ShieldCheck, ShoppingBag, User } from 'lucide-react';

const fallbackNavigation = [
    { label: 'Home', href: '/' },
    { label: 'All Products', href: '/shop' },
    { label: 'Beauty Collections', href: '/collections' },
    { label: 'New In', href: '/new-in' },
    { label: 'Best Sellers', href: '/shop' },
];

export function Header() {
    const { navigation = {}, auth = {}, settings = {}, theme3InitLoad = {} } = usePage().props;
    const user = auth.user ?? null;
    const isAdminUser = ['admin', 'superadmin'].includes(
        String(user?.user_type ?? '').toLowerCase(),
    );
    const brand = theme3InitLoad.brand ?? {};
    const appLogo = brand.logo;
    const appName = brand.shortName || brand.title || brand.name || settings.name || 'Captex';
    const visibleNavigation = (navigation.mainNavigation ?? fallbackNavigation).filter(
        (item) => item?.label && item?.href,
    );
    const accountHref = user ? '/account' : '/login';
    const adminHref = isAdminUser ? '/admin' : '/admin/login';

    return (
        <header className="sticky top-0 z-50">
            <div className=" overflow-hidden bg-white/95 shadow-[0_10px_40px_rgba(191,24,91,0.08)] backdrop-blur-md">
                <div className=" w-full mx-auto  max-w-[1440px] flex items-center gap-3 px-4 py-3 sm:px-6 lg:px-10">
                    <Link href="/" className="flex shrink-0 items-center gap-3">
                        <img
                            src={appLogo}
                            alt={appName}
                            className="h-13 bg-white object-contain "
                        />


                    </Link>

                    <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
                        {visibleNavigation.map((item, index) => (
                            <Link
                                key={item.label}
                                href={item.href}
                                className={[
                                    'rounded-full px-3 py-2 text-[10px] font-semibold uppercase transition',
                                    index === 0
                                        ? 'bg-[#ffe7ef] text-[#d80b67] ring-1 ring-[#f5b4c8]'
                                        : 'text-slate-800 hover:bg-rose-50 hover:text-[#d80b67]',
                                ].join(' ')}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </nav>

                    <div className="ml-auto flex items-center gap-2 sm:gap-3">
                        <label className="hidden items-center rounded-full border border-rose-200 bg-white px-3 py-2 shadow-sm shadow-rose-100/60 md:flex xl:px-4 xl:py-3">
                            <input
                                className="w-36 bg-transparent text-sm outline-none placeholder:text-slate-400 sm:w-44 xl:w-56"
                                type="search"
                                placeholder="Search products"
                            />
                        </label>

                        <button
                            type="button"
                            className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#f51b75] text-white shadow-lg shadow-pink-200 transition hover:-translate-y-0.5 hover:bg-[#d80b67] sm:h-11 sm:w-11"
                            aria-label="Search"
                        >
                            <Search className="h-4 w-4 sm:h-5 sm:w-5" />
                        </button>

                        <Link
                            href={accountHref}
                            className="hidden h-10 rounded-full border border-rose-200 bg-white px-3 text-xs font-semibold text-slate-700 shadow-sm shadow-rose-100 transition hover:-translate-y-0.5 hover:border-[#f51b75] hover:text-[#d80b67] sm:inline-flex sm:items-center sm:gap-2 sm:h-11 sm:px-4 sm:text-sm"
                            aria-label={user ? 'Account' : 'Login'}
                        >
                            <User className="h-4 w-4" />
                            <span className="hidden xl:inline">{user ? 'Account' : 'Login'}</span>
                        </Link>

                        <Link
                            href="/wishlist"
                            className="hidden h-10 rounded-full border border-rose-200 bg-white px-3 text-xs font-semibold text-slate-700 shadow-sm shadow-rose-100 transition hover:-translate-y-0.5 hover:border-[#f51b75] hover:text-[#d80b67] sm:inline-flex sm:items-center sm:gap-2 sm:h-11 sm:px-4 sm:text-sm"
                            aria-label="Wishlist"
                        >
                            <Heart className="h-4 w-4" />
                            <span className="hidden xl:inline">Wishlist</span>
                        </Link>



                        <Link
                            className="hidden h-10 rounded-full border border-rose-200 bg-white px-3 text-xs font-semibold text-slate-700 shadow-sm shadow-rose-100 transition hover:border-[#f51b75] hover:text-[#d80b67] sm:inline-flex sm:items-center sm:gap-2 sm:h-11 sm:px-4 sm:text-sm"
                            href="/checkout"
                            aria-label="Cart"
                        >
                            <ShoppingBag className="h-4 w-4" />
                        </Link>

                        <Link
                            href={accountHref}
                            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-rose-200 bg-white text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-[#f51b75] hover:text-[#d80b67] lg:hidden"
                            aria-label={user ? 'Account' : 'Login'}
                        >
                            <User className="h-4 w-4" />
                        </Link>

                        <Link
                            href="/wishlist"
                            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-rose-200 bg-white text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:border-[#f51b75] hover:text-[#d80b67] lg:hidden"
                            aria-label="Wishlist"
                        >
                            <Heart className="h-4 w-4" />
                        </Link>

                   
                    </div>
                </div>

                <div className="border-t border-rose-100 px-4 pb-4 sm:px-6 lg:hidden">
                    <div className="flex gap-3 overflow-x-auto whitespace-nowrap">
                        {visibleNavigation.map((item, index) => (
                            <Link
                                key={item.label}
                                href={item.href}
                                className={[
                                    'rounded-full px-4 py-2 text-sm font-semibold ring-1 ring-rose-100',
                                    index === 0
                                        ? 'bg-[#ffe7ef] text-[#d80b67]'
                                        : 'bg-white text-slate-700',
                                ].join(' ')}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
}
